module.exports = __webpack_public_path__ + "img/goods4_2.115deea3.jpg";